import React, { useState } from 'react';
import { IntlProvider } from 'react-intl';
import Vietnamese from './locales/vi_VN.js';
import English from './locales/en_US.js';
import French from './locales/fr_FR.js';

export const Context = React.createContext();

const browserLang = navigator.language || navigator.userLanguage;
console.log('browserLang', browserLang);
// const local = 'en';
let local = 'fr';
let lang = French;
if (browserLang.includes('fr')) {
  local = 'fr';
  lang = French;
} else {
  local = 'fr';
  lang = French;
}

const Wrapper = (props) => {
  const [locale, setLocale] = useState(local);

  const [messages, setMessages] = useState(lang);

  function selectLanguage(e) {
    const newLocale = e.target.value;
    setLocale(newLocale);
    if (newLocale === 'fr') {
      setMessages(French);
    } else {
      setMessages(English);
    }
  }

  // return (
  //     <Context.Provider value={{ locale, selectLanguage }}>
  //         <IntlProvider messages={messages} locale={locale}>
  //             {props.children}
  //         </IntlProvider>
  //     </Context.Provider>

  // );

  return (
    <Context.Provider value={{ locale: 'vi', selectLanguage }}>
      <IntlProvider messages={messages} locale={locale}>
        {props.children}
      </IntlProvider>
    </Context.Provider>
  );
};

export default Wrapper;
